import { Routes } from '@angular/router';


export const routes: Routes = [
  {
    path: '', children: [
      {
        path: '', loadComponent: () => import('./email-marketing.component').then(m => m.EmailMarketingComponent),
        data: {
          title: 'KudosHub | Email Marketing',
          description:'Send emails to the right person at the right time and creative responsive marketing campaigns within minutes.',
          keywords: 'email marketing, email campaigns',
          ogTitle: 'KudosHub | Email Marketing',
          ogDesc: 'Send emails to the right person at the right time and creative responsive marketing campaigns within minutes.',
          ogImage: 'https://kudoshub.com/theme/images/og-images/email-marketing-service.webp',
          ogUrl: 'https://kudoshub.com/email-marketing',
          twitterTitle: 'KudosHub | Email Marketing',
          twitterDesc: 'Send emails to the right person at the right time and creative responsive marketing campaigns within minutes.',
          twitterImage: 'https://kudoshub.com/theme/images/og-images/email-marketing-service.webp'
        }
      }
    ]
  }
];
